module.exports = __webpack_public_path__ + "static/media/moon_small.ea795070.jpg";